import { Typography } from "antd"
import styled from "styled-components"

import Flex from "#blocks/Flex"

import {
  type PortfolioMockProfile,
  type PortfolioMockProject,
} from "./usePortfolioDbStorage"

const { Paragraph, Text } = Typography

const SFieldLabel = styled(Text).attrs({ type: "secondary" })`
  font-size: 12px;
  display: block;
  margin-bottom: 4px;
`

interface ProjectDetailsPopoverContentProps {
  project: PortfolioMockProject
  updateProject: (
    projectId: string,
    updates: Partial<
      Pick<
        PortfolioMockProject,
        "title" | "notes" | "dimensions" | "materials" | "processes" | "ideas"
      >
    >
  ) => void
  portfolioProfile: PortfolioMockProfile
  updatePortfolioProfile: (updates: Partial<PortfolioMockProfile>) => void
}

const ProjectDetailsPopoverContent = ({
  project,
  updateProject,
  portfolioProfile,
  updatePortfolioProfile,
}: ProjectDetailsPopoverContentProps) => {
  return (
    <Flex col gap={14} style={{ minWidth: 280, maxWidth: 440 }}>
      <div>
        <SFieldLabel>Title</SFieldLabel>
        <Paragraph
          editable={{
            onChange: (value) => updateProject(project.id, { title: value }),
          }}
          style={{ marginBottom: 0 }}
        >
          {project.title}
        </Paragraph>
      </div>
      <div>
        <SFieldLabel>Notes</SFieldLabel>
        <Paragraph
          editable={{
            onChange: (value) => updateProject(project.id, { notes: value }),
            autoSize: { minRows: 2, maxRows: 8 },
          }}
          style={{ marginBottom: 0, whiteSpace: "pre-wrap" }}
        >
          {project.notes ?? ""}
        </Paragraph>
      </div>
      <div>
        <SFieldLabel>Dimensions</SFieldLabel>
        <Paragraph
          editable={{
            onChange: (value) =>
              updateProject(project.id, { dimensions: value }),
          }}
          style={{ marginBottom: 0 }}
        >
          {project.dimensions ?? ""}
        </Paragraph>
      </div>
      <div>
        <SFieldLabel>Materials</SFieldLabel>
        <Paragraph
          editable={{
            onChange: (value) =>
              updateProject(project.id, { materials: value }),
          }}
          style={{ marginBottom: 0 }}
        >
          {project.materials ?? ""}
        </Paragraph>
      </div>
      <div>
        <SFieldLabel>Processes</SFieldLabel>
        <Paragraph
          editable={{
            onChange: (value) =>
              updateProject(project.id, { processes: value }),
          }}
          style={{ marginBottom: 0 }}
        >
          {project.processes ?? ""}
        </Paragraph>
      </div>
      <div>
        <SFieldLabel>Ideas</SFieldLabel>
        <Paragraph
          editable={{
            onChange: (value) => updateProject(project.id, { ideas: value }),
            autoSize: { minRows: 2, maxRows: 8 },
          }}
          style={{ marginBottom: 0, whiteSpace: "pre-wrap" }}
        >
          {project.ideas ?? ""}
        </Paragraph>
      </div>
      <div>
        <SFieldLabel>Canva Organization Link</SFieldLabel>
        <Paragraph
          editable={{
            onChange: (value) => updatePortfolioProfile({ canvaLink: value }),
          }}
          style={{ marginBottom: 0 }}
        >
          {portfolioProfile.canvaLink || ""}
        </Paragraph>
      </div>
    </Flex>
  )
}

export default ProjectDetailsPopoverContent
